<template>
  <div class="container">
    <h1>Create Anchor Page with Access Points</h1>
    <form @submit.prevent="onSubmit">
      <div class="form-group">
        <label for="anchor-title">Title</label>
        <input
          type="text"
          id="anchor-title"
          class="form-control"
          placeholder="Title for new anchor page with access points"
          v-model="title">
      </div>
      <button
        type="submit"
        class="btn btn-primary"
        :disabled="!title || creating">
        <template v-if="creating">
          <i class="fa fa-cirlce-o-notch fa-spin"/> Creating...
        </template>
        <template v-else>
          Create
        </template>
      </button>
    </form>
  </div>
</template>

<script>
import { create } from '@/admin/api/anchorpages'
import { Notification } from 'uiv'

export default {
  name: 'NewAnchorAccessPoints',
  data() {
    return {
      title: '',
      creating: false
    }
  },
  methods: {
    async onSubmit() {
      if (!this.title) {
        return
      }

      this.creating = true
      try {
        let gradeLevelUUID = await create(this.title)
        this.$router.push({
          name: 'EditAnchorAccessPoints',
          params: { uuid: gradeLevelUUID }
        })
      } catch (err) {
        console.error(err)
        Notification.notify.error({
          title: 'Could not create anchor page',
          content: err.message,
          duration: 0,
          offsetY: 65
        })
      } finally {
        this.creating = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
